'use es6';

export default function reduceReducers(...reducers) {
  return (previousState, currentAction) => reducers.reduce((state, reducer) => reducer(state, currentAction), previousState);
}